/**
 * Created by nghinv on Tue Jul 13 2021
 * Copyright (c) 2021 nghinv@lumi.biz
 */

import Badge from '@nghinv/react-native-badge';
import SearchBar from '@nghinv/react-native-search-bar';
import Switch from '@nghinv/react-native-switch';
import Avatar from './components/Avatar';
import Button from './components/Button/Button';
import ButtonIcon from './components/Button/ButtonIcon';
import ButtonText from './components/Button/ButtonText';
import Card from './components/Card';
import Container from './components/Container';
import Divider from './components/Divider';
import EnvironmentBanner from './components/EnvironmentBanner';
import Row from './components/Row/Row';
import SizeBox from './components/SizeBox';
import Space from './components/Space';
import Text from './components/Text';
import ServiceProviderWithTheme from './components/ServiceProviderWithTheme';

export * from '@nghinv/react-native-theme';

export {
  Avatar,
  Badge,
  Button,
  ButtonIcon,
  ButtonText,
  Card,
  Container,
  Divider,
  EnvironmentBanner,
  Row,
  ServiceProviderWithTheme,
  SearchBar,
  SizeBox,
  Space,
  Switch,
  Text,
};
